import AnalyticsHelper from '../../utils/analytics-helper';

export default class KeyFeaturesModal {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el.querySelector('.configurator--key-features-modal');
        this.data = parent.data;
        this.close = this.el.querySelector('.modal-close');
        this.keyFeatures = [...this.el.querySelectorAll('.key-feature')];
        this.mtoKeyFeatureLinks = [...this.parent.el.querySelectorAll('.mto-key-features-link')];
        this.gradeName = this.el.querySelector('.grade-name');
        this.bind();
    }

    bind() {
        this.close.addEventListener('click', (e) => this.hide());
        this.el.addEventListener('click', (e) => {
            if (!e.target.closest('.modal-container')) {
                this.hide();
            }
        });
        this.mtoKeyFeatureLinks.forEach((l) => l.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            AnalyticsHelper.push(l);
            this.show(e.currentTarget.dataset.id);
        }));
    }

    show(code) {
        const carData = this.data.carMap[code];
        const features = carData?.keyFeatures || [];
        this.gradeName.textContent = carData?.gradeName;
        this.keyFeatures.forEach((kf) => (features.includes(kf.dataset.id) ? kf.classList.remove('hide') : kf.classList.add('hide')));
        this.el.showModal();
        this.el.querySelector('.modal-close').focus({ preventScroll: true });
    }

    hide() {
        this.el.close();
    }
}
